import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'cream' | 'teal' | 'orange';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    cream: 'bg-[#FFFDF5]',
    teal: 'bg-[#E6F4F4]',
    orange: 'bg-[#FFF5F0]'
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-492">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-493">{children}</div>
    </section>;
}